import { createNovaChatClient } from '@novachat/client';
import { desktop } from './desktop';

/** Production talks to chat-api directly; the dev server forwards same-origin calls (vite.config.ts). */
export const apiUrl = import.meta.env.DEV ? '' : (import.meta.env.VITE_API_URL ?? 'https://chat-api.novadan.dev');
const wsUrl = import.meta.env.DEV
  ? `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/ws`
  : `${apiUrl.replace(/^http/, 'ws')}/ws`;

function deviceName(): string {
  const ua = navigator.userAgent;
  const browser = desktop ? 'NovaChat' : /Edg\//.test(ua) ? 'Edge' : /Firefox\//.test(ua) ? 'Firefox' : /Chrome\//.test(ua) ? 'Chrome' : /Safari\//.test(ua) ? 'Safari' : 'Tarayıcı';
  const os = /Mac OS X/.test(ua) ? 'macOS' : /Windows/.test(ua) ? 'Windows' : /Android/.test(ua) ? 'Android' : /iPhone|iPad/.test(ua) ? 'iOS' : /Linux/.test(ua) ? 'Linux' : '';
  return os ? `${browser} · ${os}` : browser;
}

export const client = createNovaChatClient({
  apiUrl,
  wsUrl,
  // The desktop app shows this same site, so it signs in like the web: refresh token in an HttpOnly cookie.
  platform: 'web',
  deviceName: deviceName(),
  ...(navigator.locks ? { locks: navigator.locks } : {}),
});
